import React from 'react';
import { Message } from 'semantic-ui-react';
import { AVAILABLE_TRANSLATION_LANGUAGES } from '../../../../constants/translations';

const FIELD_LABELS = {
  name: 'Name',
  description: 'Description',
  question: 'Question text',
  value: 'Condition value',
  values: 'Lookup value',
};

const languageName = (code) => {
  const language = AVAILABLE_TRANSLATION_LANGUAGES.find(({ value }) => value === code);
  return language ? language.text : code;
};

export const formatTranslationWarning = (warning) => {
  const path = Array.isArray(warning.path)
    ? warning.path.filter(value => typeof value === 'string' && value.trim())
    : [];
  const location = path.length > 0
    ? path.join(' → ')
    : 'Questionnaire content';
  const field = FIELD_LABELS[warning.field] || warning.field;
  const lookupPosition = warning.field === 'values' && Number.isInteger(warning.valueIndex)
    ? ` ${warning.valueIndex + 1}`
    : '';
  const details = [
    field ? `${field}${lookupPosition}` : null,
    warning.language ? languageName(warning.language) : null,
  ].filter(Boolean).join(' · ');

  return { location, details };
};

export const hasTranslationWarnings = (questionaire) => {
  const warnings = Array.isArray(questionaire.translationWarnings)
    ? questionaire.translationWarnings
    : [];
  const warningCount = questionaire.translationRun && questionaire.translationRun.warningCount;
  return Boolean(warningCount || warnings.length > 0);
};

export const TranslationWarnings = ({ questionaire }) => {
  const warnings = Array.isArray(questionaire.translationWarnings)
    ? questionaire.translationWarnings
    : [];
  const warningCount = questionaire.translationRun && questionaire.translationRun.warningCount;

  if (!hasTranslationWarnings(questionaire)) return null;

  return (
    <Message warning>
      <Message.Header>
        Review {warningCount || warnings.length} translation warning(s)
      </Message.Header>
      <p>
        The translated text matched the original English. Review these fields before activating the questionnaire.
      </p>
      {warnings.length > 0 && (
        <ul>
          {warnings.map((warning, index) => {
            const { location, details } = formatTranslationWarning(warning);
            return (
              <li key={`${location}-${details}-${index}`}>
                <strong>{location}</strong>
                {details && ` — ${details}`}
              </li>
            );
          })}
        </ul>
      )}
      {warningCount > warnings.length && (
        <p>
          Showing {warnings.length} of {warningCount} warnings.
        </p>
      )}
    </Message>
  );
};
